export default __webpack_public_path__ + "static/media/icon1.5cc369ec.svg";